export default __webpack_public_path__ + "static/media/home-landing.3f21fe94.png";